var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5707 68.4064C46.0375 68.0508 46.5787 67.8055 47.1489 67.6667C62.1694 64.0087 73.3197 50.4665 73.3197 34.32C73.3197 15.3656 57.9541 0 38.9997 0C20.0453 0 4.67969 15.3656 4.67969 34.32C4.67969 47.018 11.5757 58.1053 21.8269 64.0412C22.5601 64.4658 23.1676 65.0833 23.5391 65.8447L28.2809 75.5654C29.3874 77.8339 32.2925 78.5231 34.3001 76.9935L45.5707 68.4064Z",
    fill: "#0F4C75"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.8215,
    cy: 46.8694,
    rx: 2.43478,
    ry: 2.43478,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6309 20.4319C41.8416 19.5495 39.8309 19.2175 37.853 19.4779C35.875 19.7383 34.0187 20.5794 32.5188 21.8948C31.545 22.7488 30.7498 23.7778 30.1704 24.922C29.6498 25.9503 30.3288 27.1097 31.4422 27.408L32.1141 27.5881C33.2274 27.8864 34.3453 27.1815 35.0536 26.2723C35.2549 26.0139 35.481 25.7739 35.7295 25.5559C36.5053 24.8755 37.4655 24.4405 38.4886 24.3058C39.5116 24.1711 40.5517 24.3428 41.4772 24.7992C42.4026 25.2556 43.172 25.9762 43.688 26.8699C44.2039 27.7635 44.4433 28.7901 44.3758 29.8198C44.3083 30.8495 43.937 31.836 43.3088 32.6547C42.6806 33.4734 41.8238 34.0874 40.8466 34.4191C40.0438 34.6959 39.8277 34.6959 39.0003 34.6959L38.3047 34.6959C37.1521 34.6959 36.2177 35.6303 36.2177 36.7829V40.2612C36.2177 41.4138 37.1521 42.3481 38.3047 42.3481H39.0003C40.1529 42.3481 41.0873 41.4138 41.0873 40.2612C41.0873 39.7505 41.4573 39.3187 41.9478 39.1766C42.0979 39.1331 42.2523 39.0844 42.4119 39.0302C44.3011 38.3889 45.9576 37.2019 47.1721 35.6191C48.3866 34.0364 49.1044 32.129 49.2349 30.1383C49.3654 28.1475 48.9026 26.1628 47.9051 24.4351C46.9076 22.7074 45.4202 21.3142 43.6309 20.4319Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d817f39cd4173ae2119256a3e8df599a.svg";
export { ForwardRef as ReactComponent };